import { createSelector } from 'reselect'
import userIdSelector from './userIdSelector'
import userTypeSelector from './userTypeSelector'
import userTypes from '../../../helpers/enums/userTypes'
import viewTypes from '../../../helpers/enums/views'
import gameStates from '../../../helpers/enums/gameStates'
import { IStore } from '../../reducers/index'

const playersSelector = (state: IStore) => state.game.participants
const gameViewSelector = (state: IStore) => state.game.currentView
const activitiesSelector = (state: IStore) => state.game.activities

export default createSelector(
	userIdSelector,
	userTypeSelector,
	gameViewSelector,
	playersSelector,
	activitiesSelector,
	(id, userType, gameView, players, activities) => {
		let playerData
		if (userType === userTypes.TEACHER) {
			// TODO: this needs a better solution
			if (gameView.type === viewTypes.GAME) {
				const player = players.find(
					(player: any) =>
						player.view.type === viewTypes.GAME && player.view.payload && player.view.payload.state === gameStates.ENDED
				)
				if (player) {
					gameView = {
						...gameView,
						payload: {
							...gameView.payload,
							state: gameStates.ENDED,
						},
					}
				}
			}
			playerData = {
				view: gameView,
			}
		} else {
			const list = players
			playerData = list.find((player: any) => player.deviceUid === id)
			if (!playerData) {
				playerData = {
					view: {
						name: viewTypes.SPLASH,
						payload: {},
					},
				}
			} else {
				if (playerData.view.payload && playerData.view.payload.state === gameStates.TRANSITIONING) {
					const playerHistoryData = playerData.history[playerData.history.length - 1]

					const currentActivity = activities.find((activity) => activity.uid === playerHistoryData.activityUid)
					const correctAnswersUIds = currentActivity.payload.answers
						.filter((answer: any) => answer.correct === 1)
						.map((answer: any) => answer.uid)

					playerData = {
						...playerData,
						view: {
							...playerData.view,
							type: viewTypes.GAME,
							payload: {
								currentActivityUid: playerHistoryData.activityUid,
								answersUids: playerHistoryData.answersUids,
								correctAnswersUids: playerHistoryData.correctAnswersUids || correctAnswersUIds,
								isGameAnswered: true,
								state: playerData.view.payload.state,
							},
						},
					}
				}
			}
		}
		return playerData
	}
)
